import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "scrolling-wrapper" }
const _hoisted_2 = { class: "lCommon_shadow" }
const _hoisted_3 = { class: "lDay_headers-btns lCommon_shadow" }
const _hoisted_4 = ["data-analytics-element-name"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "lDay_homeworks"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "lDay_delimiter" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "page-day_sidebar -lessons"
}
const _hoisted_10 = { class: "-withShadowRight js-day-content page-day_content" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  class: "lDay_homeworks"
}
const _hoisted_13 = { class: "lDay_subtitle" }
const _hoisted_14 = {
  key: 4,
  class: "lDay_delimiter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_header_mobile = _resolveComponent("as-header-mobile")!
  const _component_as_alert_renew_course_mobile = _resolveComponent("as-alert-renew-course-mobile")!
  const _component_as_day_tabs = _resolveComponent("as-day-tabs")!
  const _component_as_banner_instead_video = _resolveComponent("as-banner-instead-video")!
  const _component_as_videos_player_js = _resolveComponent("as-videos-player-js")!
  const _component_as_header_video = _resolveComponent("as-header-video")!
  const _component_as_banner = _resolveComponent("as-banner")!
  const _component_as_button_chat = _resolveComponent("as-button-chat")!
  const _component_as_course_tabs = _resolveComponent("as-course-tabs")!
  const _component_as_lesson = _resolveComponent("as-lesson")!
  const _component_as_workout_list = _resolveComponent("as-workout-list")!
  const _component_as_empty = _resolveComponent("as-empty")!
  const _component_as_warning = _resolveComponent("as-warning")!
  const _component_as_homework_item = _resolveComponent("as-homework-item")!
  const _component_as_documents = _resolveComponent("as-documents")!
  const _component_as_banners_top = _resolveComponent("as-banners-top")!
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_breadcrumb = _resolveComponent("as-breadcrumb")!
  const _component_as_header_main = _resolveComponent("as-header-main")!
  const _component_as_menu = _resolveComponent("as-menu")!
  const _component_as_course_title = _resolveComponent("as-course-title")!
  const _component_as_course_progress = _resolveComponent("as-course-progress")!
  const _component_as_row = _resolveComponent("as-row")!
  const _component_as_spacer = _resolveComponent("as-spacer")!
  const _component_as_footer = _resolveComponent("as-footer")!
  const _component_as_setting_modal = _resolveComponent("as-setting-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["lCommon page-day", `pDay-${_ctx.dayId}`]),
    "data-cy": "page_day"
  }, [
    _createVNode(_component_mq_responsive, {
      target: "mobile-tablet",
      class: "lDay"
    }, {
      default: _withCtx(() => [
        (_ctx.loaded)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.course)
                ? (_openBlock(), _createBlock(_component_as_header_mobile, {
                    key: 0,
                    title: _ctx.courseTitle,
                    "prev-page": { name: 'calendar', params: { id: _ctx.streamId } },
                    "onMenu:toggle": _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenMenu = $event))
                  }, null, 8, ["title", "prev-page"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_as_alert_renew_course_mobile, { stream: _ctx.stream }, null, 8, ["stream"]), [
                [_vShow, !_ctx.isOpenMenu]
              ]),
              (_ctx.day)
                ? _withDirectives((_openBlock(), _createBlock(_component_as_day_tabs, {
                    key: 1,
                    day: _ctx.day,
                    course: _ctx.course,
                    "stream-id": _ctx.streamId,
                    progress: _ctx.progress
                  }, null, 8, ["day", "course", "stream-id", "progress"])), [
                    [_vShow, !_ctx.isOpenMenu]
                  ])
                : _createCommentVNode("", true),
              (_ctx.nextDayLoaded)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.currentLesson)
                      ? _withDirectives((_openBlock(), _createBlock(_component_as_header_video, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.bannerMobileInsteadVideo)
                              ? (_openBlock(), _createBlock(_component_as_banner_instead_video, {
                                  key: 0,
                                  banner: _ctx.bannerMobileInsteadVideo,
                                  position: _ctx.bannersPosition,
                                  placement: _ctx.bannersPlacements.insteadVideo,
                                  platform: _ctx.bannersPlatforms.mobile,
                                  onEnded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.playPlayer = true)),
                                  class: "lDay_bannerInsteadVideo"
                                }, null, 8, ["banner", "position", "placement", "platform"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_as_videos_player_js, {
                              lessonIndex: _ctx.currentLessonIndex,
                              lessons: _ctx.filteredLessons,
                              onUpdate: _ctx.selectLesson,
                              onPlay: _ctx.videoPlay,
                              onTimeupdate: _ctx.receiveVideoTime,
                              onEnded: _ctx.videoEnded,
                              onFirstPlay: _ctx.firstPlay,
                              onProgress: _ctx.updateVideoProgress,
                              play: _ctx.playPlayer,
                              "auto-play-next-video": _ctx.autoPlayNextVideoMobile
                            }, null, 8, ["lessonIndex", "lessons", "onUpdate", "onPlay", "onTimeupdate", "onEnded", "onFirstPlay", "onProgress", "play", "auto-play-next-video"])
                          ]),
                          _: 1
                        }, 512)), [
                          [_vShow, !_ctx.isOpenMenu]
                        ])
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        (_ctx.bannerMobileAfterVideo)
                          ? (_openBlock(), _createBlock(_component_as_banner, {
                              key: 0,
                              banner: _ctx.bannerMobileAfterVideo,
                              "in-day": "",
                              platform: _ctx.bannersPlatforms.mobile,
                              position: _ctx.bannersPosition,
                              placement: _ctx.bannersPlacements.afterVideo
                            }, null, 8, ["banner", "platform", "position", "placement"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_3, [
                          (_ctx.showBtnChat)
                            ? (_openBlock(), _createBlock(_component_as_button_chat, {
                                key: 0,
                                id: _ctx.chatChannelId
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('chatWithExperts')), 1)
                                ]),
                                _: 1
                              }, 8, ["id"]))
                            : _createCommentVNode("", true),
                          (_ctx.isShowBtnCourseOptions)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openLessonFilterModal && _ctx.openLessonFilterModal(...args))),
                                class: "filterBtn",
                                "data-analytics": "",
                                "data-analytics-element-type": "filters",
                                "data-analytics-element-id": "filters",
                                "data-analytics-element-name": _ctx.$t('Filters'),
                                "data-cy": "filterBtnInDay"
                              }, [
                                _hoisted_5,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('Filters')), 1)
                              ], 8, _hoisted_4))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_as_course_tabs, {
                          class: "lDay_courseTabs",
                          current: _ctx.currentTab,
                          tabs: _ctx.tabs
                        }, null, 8, ["current", "tabs"])
                      ]),
                      (_ctx.currentTab === 'lessons')
                        ? (_openBlock(), _createBlock(_component_as_workout_list, { key: 0 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLessons, (lesson, i) => {
                                return (_openBlock(), _createBlock(_component_as_lesson, {
                                  key: `lesson${i}`,
                                  lesson: lesson,
                                  class: _normalizeClass({ '-current': _ctx.currentLessonIndex === i }),
                                  onClick: ($event: any) => (_ctx.selectLesson(i)),
                                  "data-analytics": "",
                                  "data-analytics-element-type": "playlist",
                                  "data-analytics-lesson-id": lesson.id,
                                  "data-analytics-video-type": lesson.type,
                                  "data-analytics-video-orientation": lesson.orientation,
                                  "data-analytics-lesson-title": lesson.title
                                }, null, 8, ["lesson", "class", "onClick", "data-analytics-lesson-id", "data-analytics-video-type", "data-analytics-video-orientation", "data-analytics-lesson-title"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.currentTab === 'lessons' && _ctx.filteredLessons.length === 0)
                        ? (_openBlock(), _createBlock(_component_as_empty, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('lessonNotFound')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.currentTab === 'homework')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.showWarningStep)
                              ? (_openBlock(), _createBlock(_component_as_warning, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.$t('warningStep')
                                    }, null, 8, _hoisted_6)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.homeworks.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeworks, (homework, id) => {
                                    return (_openBlock(), _createBlock(_component_as_homework_item, {
                                      key: `homework${id}`,
                                      homework: homework,
                                      class: "-inner"
                                    }, null, 8, ["homework"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.currentTab === 'documents')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (_ctx.isShowDocuments)
                              ? (_openBlock(), _createBlock(_component_as_documents, {
                                  key: 0,
                                  docs: _ctx.course.documents,
                                  "instruction-url": _ctx.course.instructionUrl,
                                  title: '',
                                  class: "-day"
                                }, null, 8, ["docs", "instruction-url"]))
                              : _createCommentVNode("", true),
                            _hoisted_8
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.loaded)
                        ? (_openBlock(), _createBlock(_component_as_banners_top, {
                            key: 4,
                            banners: _ctx.bannersMobileBottom,
                            position: _ctx.bannersPosition,
                            placement: _ctx.bannersPlacements.bottom,
                            platform: _ctx.bannersPlatforms.mobile
                          }, null, 8, ["banners", "position", "placement", "platform"]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, !_ctx.isOpenMenu]
                    ])
                  ], 64))
                : _withDirectives((_openBlock(), _createBlock(_component_as_preloader, { key: 3 }, null, 512)), [
                    [_vShow, !_ctx.isOpenMenu]
                  ])
            ], 64))
          : (_openBlock(), _createBlock(_component_as_preloader, {
              key: 1,
              class: "-fullpage"
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_mq_responsive, {
      class: "lCommon page-day_wrapper bg-blue",
      target: "desktop"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_as_header_main, { class: "page-day_header" }, {
          breadcrumb: _withCtx(() => [
            _createVNode(_component_as_breadcrumb, { title: _ctx.title }, null, 8, ["title"])
          ]),
          _: 1
        }),
        _createVNode(_component_as_row, { class: "page-day_contentWrapper" }, {
          menu: _withCtx(() => [
            _createVNode(_component_as_menu, {
              class: "page-day_menu",
              mini: true,
              menu: _ctx.menu,
              type: "sidebar"
            }, null, 8, ["menu"])
          ]),
          content: _withCtx(() => [
            (_ctx.loaded)
              ? (_openBlock(), _createBlock(_component_as_banners_top, {
                  key: 0,
                  banners: _ctx.bannersTop,
                  position: _ctx.bannersPosition,
                  placement: _ctx.bannersPlacements.top,
                  platform: _ctx.bannersPlatforms.desktop
                }, null, 8, ["banners", "position", "placement", "platform"]))
              : _createCommentVNode("", true),
            _createVNode(_component_as_row, { class: "-inner -reverse" }, {
              sidebar: _withCtx(() => [
                (_ctx.loaded)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_ctx.bannerBeforeLessons)
                        ? (_openBlock(), _createBlock(_component_as_banner, {
                            key: 0,
                            banner: _ctx.bannerBeforeLessons,
                            "in-day": "",
                            platform: _ctx.bannersPlatforms.desktop,
                            position: _ctx.bannersPosition,
                            placement: _ctx.bannersPlacements.beforeLessons
                          }, null, 8, ["banner", "platform", "position", "placement"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_as_course_title, {
                        onClick: _ctx.openLessonFilterModal,
                        showButton: _ctx.isShowBtnCourseOptions
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.courseTitle), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick", "showButton"]),
                      _createVNode(_component_as_course_progress, {
                        progress: _ctx.progress,
                        videoCount: _ctx.videoCount
                      }, null, 8, ["progress", "videoCount"]),
                      _createVNode(_component_as_workout_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLessons, (lesson, i) => {
                            return (_openBlock(), _createBlock(_component_as_lesson, {
                              key: `lesson${i}`,
                              lesson: lesson,
                              class: _normalizeClass({ '-current': _ctx.currentLessonIndex === i }),
                              onClick: ($event: any) => (_ctx.selectLesson(i))
                            }, null, 8, ["lesson", "class", "onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      (_ctx.filteredLessons.length === 0)
                        ? (_openBlock(), _createBlock(_component_as_empty, { key: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('lessonNotFound')), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.loaded)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.currentLesson)
                          ? (_openBlock(), _createBlock(_component_as_header_video, { key: 0 }, {
                              default: _withCtx(() => [
                                (_ctx.bannerInsteadVideo)
                                  ? (_openBlock(), _createBlock(_component_as_banner_instead_video, {
                                      key: 0,
                                      banner: _ctx.bannerInsteadVideo,
                                      position: _ctx.bannersPosition,
                                      placement: _ctx.bannersPlacements.insteadVideo,
                                      platform: _ctx.bannersPlatforms.desktop,
                                      onEnded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.playPlayer = true)),
                                      class: "lDay_bannerInsteadVideo"
                                    }, null, 8, ["banner", "position", "placement", "platform"]))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_as_videos_player_js, {
                                  lessonIndex: _ctx.currentLessonIndex,
                                  lessons: _ctx.filteredLessons,
                                  onUpdate: _ctx.selectLesson,
                                  onPlay: _ctx.videoPlay,
                                  onTimeupdate: _ctx.receiveVideoTime,
                                  onEnded: _ctx.videoEnded,
                                  onFirstPlay: _ctx.firstPlay,
                                  onProgress: _ctx.updateVideoProgress,
                                  play: _ctx.playPlayer,
                                  "auto-play-next-video": _ctx.autoPlayNextVideo
                                }, null, 8, ["lessonIndex", "lessons", "onUpdate", "onPlay", "onTimeupdate", "onEnded", "onFirstPlay", "onProgress", "play", "auto-play-next-video"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.showWarningStep)
                          ? (_openBlock(), _createBlock(_component_as_warning, {
                              key: 1,
                              class: "-big"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.$t('warningStep')
                                }, null, 8, _hoisted_11)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.homeworks.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('homeworks')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeworks, (homework, id) => {
                                return (_openBlock(), _createBlock(_component_as_homework_item, {
                                  key: `homework${id}`,
                                  homework: homework,
                                  class: "-inner"
                                }, null, 8, ["homework"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowDocuments)
                          ? (_openBlock(), _createBlock(_component_as_documents, {
                              key: 3,
                              docs: _ctx.course.documents,
                              "instruction-url": _ctx.course.instructionUrl
                            }, null, 8, ["docs", "instruction-url"]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowDocuments)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                          : _createCommentVNode("", true),
                        (_ctx.showBtnChat)
                          ? (_openBlock(), _createBlock(_component_as_button_chat, {
                              key: 5,
                              id: _ctx.chatChannelId
                            }, null, 8, ["id"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createBlock(_component_as_preloader, { key: 1 }))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_as_spacer),
            (_ctx.loaded)
              ? (_openBlock(), _createBlock(_component_as_banners_top, {
                  key: 1,
                  banners: _ctx.bannersBottom,
                  position: _ctx.bannersPosition,
                  placement: _ctx.bannersPlacements.bottom,
                  platform: _ctx.bannersPlatforms.desktop
                }, null, 8, ["banners", "position", "placement", "platform"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_as_footer, { class: "page-day_footer" })
      ]),
      _: 1
    }),
    _createVNode(_component_as_setting_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modal) = $event)),
      options: _ctx.options,
      filters: _ctx.filters,
      streamId: _ctx.streamId,
      courseId: _ctx.courseId,
      dayId: _ctx.dayId
    }, null, 8, ["modelValue", "options", "filters", "streamId", "courseId", "dayId"])
  ], 2))
}